// extracted by mini-css-extract-plugin
export default {"icon":"Pinterest_icon__Mx9wO","disabled":"Pinterest_disabled__rleoV"};